import React from "react";
import { Card } from "@campgladiator/cgui-core.atoms.card";
import { ProgramScheduleDTO } from "@campgladiator/cg-common.types.types";
import {
  getFormattedWeekDays,
  formatTime,
} from "@campgladiator/cg-common.utility.dates";
import { Divider } from "@campgladiator/cgui-core.atoms.divider";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Input } from "@campgladiator/cgui-core.atoms.input";
import { ProductHeading } from "../ProductHeading";
import { UpgradeMembershipModalProps } from "../../";
import styles from "./SelectSchedule.module.scss";

export type SelectScheduleOptions = {
  checked: boolean;
} & ProgramScheduleDTO;

export type SelectScheduleProps = {
  handleChange: (id: string, checked: boolean) => void;
  selectScheduleOptions: SelectScheduleOptions[];
} & Pick<UpgradeMembershipModalProps, "productName" | "productPrice">;

const SelectSchedule = ({
  productName,
  productPrice,
  selectScheduleOptions,
  handleChange,
}: SelectScheduleProps) => {
  return (
    <>
      <ProductHeading productName={productName} productPrice={productPrice} />
      <div className={styles.cardWrapper}>
        {selectScheduleOptions.map((programSchedule) => {
          const daysOfTheWeek = getFormattedWeekDays({
            daysOfTheWeek: programSchedule.daysOfTheWeek,
          });
          const startTime = formatTime(programSchedule.startTime);

          return (
            <div key={programSchedule.id} className={styles.cardContainer}>
              <Card
                flat
                className={styles.card}
                onClick={() =>
                  handleChange(programSchedule.id, !programSchedule.checked)
                }
              >
                <div className={styles.inputContainer}>
                  <Input
                    className={styles.input}
                    id={`radio-card-${programSchedule.id}`}
                    name="radio-card"
                    type="radio"
                    value={programSchedule.id}
                    checked={programSchedule.checked}
                  />
                </div>
                <div className={styles.locationTrainerName}>
                  <div className={styles.time}>
                    <Paragraph size="xsmall">{daysOfTheWeek}</Paragraph>
                    <Paragraph size="xsmall">{startTime}</Paragraph>
                  </div>
                  <Divider className={styles.divider} />
                  <div className={styles.locationName}>
                    <Paragraph size="xsmall">
                      {programSchedule?.address?.name ?? ""}
                    </Paragraph>
                    <Paragraph size="xsmall" weight="book">
                      {programSchedule?.address?.address1 ?? ""}
                      {programSchedule.approvalRequired === "ONLINE" &&
                        "Online"}
                    </Paragraph>
                  </div>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SelectSchedule;
